import { defineStore as definePiniaStore } from "pinia";

/**
 * Base interface enforcing reset method on all TellScale stores
 *
 * This ensures every store can be reset to its initial state,
 * enabling the auto-reset functionality in the app store
 */
export interface IBaseStore {
    /**
     * Reset store to its initial state
     */
    reset: () => void;
}

/**
 * Type-safe store factory enforcing IBaseStore interface
 *
 * USAGE: Import this instead of Pinia's defineStore to ensure all stores
 * implement the required reset method for auto-discovery
 *
 * @param {string} id - Unique store identifier
 * @param {Function} setup - Store setup function that must return IBaseStore
 * @returns Pinia store definition
 *
 * @example
 * export const useMyStore = defineStore('my-store', () => {
 *   const state = ref([]);
 *
 *   const reset = () => {
 *     state.value = [];
 *   };
 *
 *   return { state, reset };
 * });
 */
export function defineStore<T extends IBaseStore>(id: string, setup: () => T) {
    return definePiniaStore(id, setup);
}